import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_trademachine.png",
      alt: "Estratégias Agilebox",
    },
    title: "TradeMachine",

    // String ou array de strings
    text: "A primeira casa de análise automatizada e quantitativa. A TradeMachine é uma fintech que automatiza investimentos em renda variável para quem quer diversificar seus investimentos de maneira simples e com segurança tecnológica, focando na melhor experiência do cliente.",
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },

  strategies: {
    title: "Estratégias TradeMachine",
    heading: "Tenha acesso às melhores estratégias de day trade",
    subtitle:
      "Estratégias feitas por profissionais com mais de 10 anos de mercado financeiro, validadas entre inúmeros clientes e grandes empresas. Fácil e rápido. Com um clique opere as estratégias de gigantes.",
  },

  cta: {
    title: "Vamos começar? ",
    subtitle: "Ative sua estratégia TradeMachine agora!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A TradeMachine",
    col1: [
      "Em 2012, como assessores da XP Investimentos, os sócios da TradeMachine foram os um dos primeiros entusiastas da utilização de Robôs de investimento no Brasil, buscando levar diversificação para seus clientes.",
      "Com a experiência adquirida e após aprofundar seus conhecimentos em tecnologia passou a desenvolver seus próprios robôs automatizados, surgindo assim, em 2018, a TradeMachine.",
    ],
    col2: [
      "Dessa forma a TradeMachine se tornou a primeira casa de análises automatizada do Brasil a ser credenciada pela APIMEC. Ao combinar estatística e tecnologia automatiza investimentos em renda variável para quem quer diversificar seus investimentos de maneira simples e com segurança tecnológica, focando na melhor experiência do cliente.",
    ],
  },

  stats: {
    title: "Nossos indicadores de performance",
    subtitle:
      "Há 5 anos desenvolvendo estratégias validadas pelos melhores profissionais do setor",
    data: [
      {
        value: "+2k",
        description: "Clientes já operaram com o Destiny",
      },
      {
        value: "65",
        description: "Parâmetros ajustáveis dinamicamente com o mercado",
      },
      {
        value: "+70%",
        description: "De taxa de acerto",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Agile?",
    subtitle: "Veja quais as principais vantagens dos robôs da Agile.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "30 dias para testar",
        description:
          "Neste primeiro mês daremos 30 dias grátis para nossos assinantes",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description: "Somos a primeira casa de análise 100% automatizada",
      },
      {
        icon: iconsSet.paper_board,
        title: "Modelos matemáticos",
        description:
          "Estratégias baseadas em modelos matemáticos como correlação, cointegração e Monte Carlo.",
      },
      {
        icon: iconsSet.growth,
        title: "Aumento nas suas chances de sucesso",
        description:
          "Nosso robô de inteligência artificial (IA) encontra as melhores oportunidades de negociações, melhorando suas chances de sucesso.",
      },
      {
        icon: iconsSet.update,
        title: "Baixa frequência de operação",
        description: "Operar pouco para operar bem.",
      },
      {
        icon: iconsSet.lock,
        title: "Segurança",
        description:
          "Temos em nossos robôs diversas ferramentas de verificações de segurança para garantir a precisão da estratégia.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão TradeMachine",
  },

  testimonials: [
    {
      text: "Melhores robôs do Brasil",
      author: "Moisés Dörr",
      job: "Educador Financeiro",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "A TradeMachine me ajudou a ficar positivo todos esses anos. Trouxe segurança e rentabilidade para uma carteira de investimento que não teve trégua desde a pandemia.",
      author: "Wagner Vasques",
      job: "Mecânico de aeronaves",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
